module.exports = __webpack_public_path__ + "img/026-qatar.98b79a37.svg";